import styled from 'styled-components';
import { Switch } from 'antd';

export const SwitchEmail = styled(Switch)`
  min-width: fit-content;
  height: 25px;

  .ant-switch-handle {
    top: 4px;
  }

  .ant-switch-inner {
    height: 85%;
  }
`;
